import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import editIcon from '/src/assets/images/button/edit-square.svg?url';
import ErrorBox from '../Identity/ErrorBox';
import { ACTION_BLUE, outlinedButtonSx, SPACING } from '../../../theme/theme';
import Breadcrumb from '../../Navigation/Breadcrumb';

// No horizontal padding and no re-centring: the parent (ContentWrapper in
// pages/Dashboard/Identity.tsx) already centres and pads this, so the old
// `padding` plus `left: 50% / translateX(-50%)` shifted the navbar and the
// error box off the card grid's left and right edges.
const NavbarContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1100px',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  marginBottom: `${SPACING.md}px`,
  boxSizing: 'border-box',
}));

const TopRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

const StyledButton = styled(Box)(() => ({
  fontFamily: 'IRANYekanXFaNum',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  width: '150px',
  height: '40px',
  borderRadius: '8px',
  padding: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  ...outlinedButtonSx,
  '@media (max-width: 768px)': {
    width: '140px',
    fontSize: '12px',
    marginTop: '3px',
    height: '32px',
    padding: '4px 6px',
    gap: '4px',
    alignSelf: 'center',
  },
}));

interface IdentifyNavbarProps {
  publisherId: string;
  identify: string;
  errors?: Record<string, string>;
}
const PageContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: '0px',
  padding: '16px',
  backgroundColor: 'inherit',
});

const IdentifyNavbar: React.FC<IdentifyNavbarProps> = ({
  publisherId,
  identify,
  errors,
}) => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      
      <Breadcrumb
        items={[
          { label: 'داشبورد', to: '/dashboard' },
          { label: 'هویت‌ها', to: '/identities' },
          { label: 'تنظیمات هویت' },
        ]}
      />
    <NavbarContainer style={{marginTop: '20px',
            padding:'10px',
            backgroundColor: 'white',
            borderRadius: '12px',
            border: 'none',
            boxShadow: '0 2px 10px rgba(16, 24, 40, 0.06)'}}>
      
      <TopRow>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 600,
            fontSize: { xs: '14px', sm: '16px' },
            color: 'text.primary',
            textAlign: 'right',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          تنظیمات هویت
        </Typography>

        <Box
          sx={{
            display: 'flex',
            // Pixel value — the theme sets spacing to 1, so this was a 1px gap.
            gap: `${SPACING.sm}px`,
            flexDirection: 'row',
            width: { xs: '100%', sm: 'auto' },
            alignItems: { xs: 'center', sm: 'flex-start' },
            justifyContent: { xs: 'center', sm: 'flex-start' },
          }}
        >
          <StyledButton
            onClick={() =>
              navigate('/dashboard/edit-identity', {
                state: { publisherId, identify },
              })
            }
          >
            <Box
              component="img"
              src={editIcon}
              alt="icon"
              sx={{
                width: { xs: '18px', sm: '20px' },
                height: { xs: '18px', sm: '20px' },
              }}
            />
            <Typography
              variant="body2"
              sx={{
                fontFamily: 'IRANYekanXFaNum',
                fontWeight: 500,
                fontSize: { xs: '12px', sm: '14px' },
                // inherit so the button's hover can flip it to white.
                color: ACTION_BLUE,
              }}
            >
              ویرایش اطلاعات
            </Typography>
          </StyledButton>
        </Box>
      </TopRow>

      {errors && Object.keys(errors).length > 0 && <ErrorBox errors={errors} />}
    </NavbarContainer>
    </PageContainer>
  );
};

export default IdentifyNavbar;
